import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.SUPER_ADMIN };
const path = "admin/early-access";

export const List = async (params) => {
    return await axiosInstance(options).get(`${path}/list`, { params });
};

export const StatusChange = async (data) => {
    return await axiosInstance(options).post(`${path}/status-change`, data);
};
